import { render, staticRenderFns } from "./datetime-picker.vue?vue&type=template&id=5a2165f0"
import script from "./datetime-picker.vue?vue&type=script&lang=js"
export * from "./datetime-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports